import useSWRMutation from "swr/mutation";
import { TypedDocumentString } from "../generated/graphql";
import graphQLFetcher from "../index";

// Hand-written ahead of codegen -- see useDeleteLibertyAIConversation.ts for
// why. Delete this file's local Document/types once
// `setLibertyAIConversationReadState` ships and codegen generates the real ones.
export interface SetLibertyAiConversationReadStateMutationVariables {
  id: string;
  read: boolean;
}

export interface SetLibertyAiConversationReadStateMutation {
  __typename?: "Mutation";
  setLibertyAIConversationReadState: {
    __typename?: "LibertyAIConversation";
    id: string;
    lastReadAt?: string | null;
  };
}

const SetLibertyAiConversationReadStateDocument = new TypedDocumentString(`
    mutation SetLibertyAIConversationReadState($id: ID!, $read: Boolean!) {
  setLibertyAIConversationReadState(id: $id, read: $read) {
    id
    lastReadAt
  }
}
    `) as unknown as TypedDocumentString<
  SetLibertyAiConversationReadStateMutation,
  SetLibertyAiConversationReadStateMutationVariables
>;

export interface UseSetLibertyAIConversationReadStateResponse {
  setLibertyAIConversationReadState: (
    variables: SetLibertyAiConversationReadStateMutationVariables,
  ) => Promise<SetLibertyAiConversationReadStateMutation | undefined>;
  loading: boolean;
  error: Error | undefined;
}

export function useSetLibertyAIConversationReadState(): UseSetLibertyAIConversationReadStateResponse {
  const { error, isMutating, trigger } = useSWRMutation<
    SetLibertyAiConversationReadStateMutation,
    Error,
    string,
    SetLibertyAiConversationReadStateMutationVariables
  >(
    "setLibertyAIConversationReadState",
    async (
      _key,
      { arg }: { arg: SetLibertyAiConversationReadStateMutationVariables },
    ) => {
      return graphQLFetcher(SetLibertyAiConversationReadStateDocument, arg);
    },
  );

  return {
    setLibertyAIConversationReadState: trigger,
    loading: isMutating,
    error,
  };
}
